import React, { useContext, useEffect, useState } from "react";
import FormHeaderSection from "./FormHeaderSection";
import FormInputSection from "./FormInputSection";
import { EditSizeChartContext } from "../../../Context/EditSizeChartContext";
import { getDefaultFormObjectByCategory } from "../../AddSizeChart/SizeChartFormsData";
import SizeNameInput from "./SizeNameInput";
import { getSizeChartColumnWidth } from "../../../lib/utils/utils";

function SizesForm() {
    const { sizeChartFormData, setSizeChartFormData, selectedCategory } = useContext(EditSizeChartContext);
    const [categoryKeys, setCategoryKeys] = useState([]);

    const formatHeaderTitle = (text) => {
        if (!text) return "";
        return text
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (s) => s.toUpperCase())
            .trim();
    };

    const handleInputChange = (id, field, unit = null, value) => {
        const updatedData = sizeChartFormData.map((item) => {
            if (item.id === id) {
                if (unit) {
                    return {
                        ...item,
                        [field]: { ...item[field], [unit]: value },
                    };
                } else {
                    return { ...item, [field]: value };
                }
            }
            return item;
        });

        setSizeChartFormData(updatedData);
    };

    useEffect(() => {
        if (sizeChartFormData.length === 0) return;

        const categoryItems = getDefaultFormObjectByCategory(selectedCategory);
        const baseKeys = Object.keys(categoryItems || {}).filter((k) => k !== "id");
        const currentKeys = Object.keys(sizeChartFormData[0]).filter((k) => k !== "id");

        const mergedKeys = [
            ...baseKeys.filter((key) => currentKeys.includes(key)),
            ...currentKeys.filter((key) => !baseKeys.includes(key)),
        ];

        setCategoryKeys(mergedKeys);
    }, [selectedCategory, sizeChartFormData]);

    return (
        <div className="w-fit border border-[#EAEAEA] rounded-lg overflow-x-auto">
            {/* Header Row */}
            <div
                className={`w-fit flex items-center text-[16px] leading-[22px] text-[#121212] font-normal ${
                    sizeChartFormData.length > 0 ? "border-b border-[#EAEAEA]" : ""
                }`}
            >
                {categoryKeys.map((key, index) => {
                    const isLast = index === categoryKeys.length - 1;
                    const columnWidth = getSizeChartColumnWidth(key, selectedCategory);

                    if (key === "sizeName") {
                        return (
                            <div
                                key={key}
                                className={`w-[180px] ${columnWidth || ""} h-[94px] shrink-0 px-6 py-3 flex items-center justify-center ${
                                    !isLast ? "border-r border-[#EAEAEA]" : ""
                                }`}
                            >
                                <p>Size</p>
                            </div>
                        );
                    }

                    return (
                        <FormHeaderSection
                            key={key}
                            isLast={isLast}
                            title={
                                (selectedCategory === "Shoe & Sandals" || selectedCategory === "High Heels")
                                    ? sizeChartFormData[0]?.[key]?.sizeName || formatHeaderTitle(key)
                                    : formatHeaderTitle(key)
                            }
                        />
                    );
                })}
            </div>

            {/* Input Rows */}
            {sizeChartFormData?.length > 0 &&
                sizeChartFormData.map((row, rowIndex) => {
                    const isLastRow = rowIndex === sizeChartFormData.length - 1;

                    return (
                        <div
                            key={row.id}
                            className={`w-fit flex items-center ${
                                !isLastRow ? "border-b border-[#EAEAEA]" : ""
                            } text-[16px] leading-[22px] font-normal text-[#121212]`}
                        >
                            {categoryKeys.map((key, keyIndex) => {
                                const isLastColumn = keyIndex === categoryKeys.length - 1;
                                const columnWidth = getSizeChartColumnWidth(key, selectedCategory);

                                if (key === "sizeName") {
                                    return (
                                        <React.Fragment key={`${row.id}-${key}`}>
                                            {selectedCategory === "Trousers, Phants, Jeans" ? (
                                                <div
                                                    className={`w-[180px] ${columnWidth || ""} px-6 py-3 border-r border-[#EAEAEA]`}
                                                >
                                                    <input
                                                        type="text"
                                                        name="sizeName"
                                                        value={row.sizeName}
                                                        onChange={(e) =>
                                                            handleInputChange(row.id, "sizeName", null, e.target.value)
                                                        }
                                                        placeholder="input"
                                                        className="w-full outline-none placeholder:text-center text-center"
                                                    />
                                                </div>
                                            ) : (
                                                <SizeNameInput
                                                    isLast={isLastColumn}
                                                    externalCSS={columnWidth}
                                                    row={row}
                                                />
                                            )}
                                        </React.Fragment>
                                    );
                                }

                                return (
                                    <FormInputSection
                                        key={`${row.id}-${key}`}
                                        row_id={row.id}
                                        spec={key}
                                        isLast={isLastColumn}
                                        externalCSS={columnWidth}
                                        centimeters={row?.[key]?.cm || ""}
                                        inches={row?.[key]?.in || ""}
                                    />
                                );
                            })}
                        </div>
                    );
                })}
        </div>
    );
}

export default SizesForm;
